export default "__VITE_ASSET__DGy2lbFU__"